export default __webpack_public_path__ + "assets/264a2f7ac2e4fbb6db6cde1b2a97e73a.ttf";